import { privacyPolicyEn } from "../pages/PrivacyPolicy/privacyPolicyTranslations";
import { termsPageEn } from "../pages/Terms/termsTranslations";

const en = {
  common: {
    language: "Language",
    polish: "PL",
    english: "EN",
    book: "Book now",
    more: "MORE",
    cartAria: "Cart, number of items: {{count}}",
    homeAria: "Go to the home page",
    openMenu: "Open menu",
    expandMenu: "Expand {{label}} menu",
    instagram: "Instagram",
    facebook: "Facebook",
    loading: "SENDING...",
    back: "BACK",
  },
  header: {
    nav: [
      {
        type: "dropdown",
        label: "Home",
        to: "/",
        items: [
          { type: "action", label: "About us", to: "/o-nas" },
          { type: "action", label: "Equipment", to: "/wyposazenie" },
          { type: "action", label: "Gallery", to: "/galeria" },
          { type: "action", label: "Virtual walk", to: "/wirtualny-spacer" },
        ],
      },
      { type: "action", label: "AI Checkup", to: "/ai-checkup" },
      { type: "action", label: "How to start", to: "/jak-zaczac" },
      {
        type: "dropdown",
        label: "Offer",
        to: "/oferta",
        items: [
          { type: "action", label: "Pricing", to: "/oferta#cennik" },
          { type: "action", label: "Gym passes", to: "/karnet" },
          { type: "action", label: "Cooperation", to: "/wspolpraca" },
        ],
      },
      {
        type: "dropdown",
        label: "Contact",
        to: "/kontakt",
        items: [
          { type: "action", label: "Location", to: "/kontakt#lokalizacja" },
          { type: "action", label: "FAQ", to: "/kontakt#faq" },
        ],
      },
    ],
  },
  footer: {
    menu: "Menu",
    home: "Home",
    offer: "Offer",
    contact: "Contact",
    privacy: "Privacy policy",
    terms: "Terms & conditions",
    stayWithUs: "Stay with us",
    email: "Email address*",
    subscribe: "SUBSCRIBE",
    subscribeSuccess: "Thank you for subscribing!",
    missingEmail: "Please enter your email address.",
    genericError: "Something went wrong. Please try again.",
    privacyConsentStart: "I accept the",
    termsConsent: "terms",
    and: "and",
    privacyConsent: "privacy policy",
    privacyError: "You must accept the terms and privacy policy.",
  },
  marquee: {
    opening: "WE ARE NOW OPEN!",
    address: "6 Krzysztofa Cedry St., Lodz",
    opening2: "50% OFF with AG50",
    address2: "Promo code valid until 31.07.2026 – 50% off entry",
  },
  cookieBanner: {
    title: "We respect your privacy",
    text1: "By using this website, you agree to the use of cookies.",
    text2a: "By clicking “Accept all”, you consent to the use of all cookies in accordance with our",
    privacyPolicy: "Privacy Policy",
    text2b: ".",
    text3: "You can change your settings at any time in the cookies section.",
    customize: "CUSTOMIZE CONSENT",
    rejectAll: "REJECT ALL",
    acceptAll: "ACCEPT ALL",
    preferencesTitle: "Customize consent",
    options: {
      necessary: {
        title: "Necessary",
        description: "These cookies are required for the website to function properly. They enable privacy settings, login, security, and core service features.",
      },
      analytics: {
        title: "Analytics",
        description: "They help us analyze website traffic and understand how users interact with the service.",
      },
      functional: {
        title: "Functional",
        description: "They allow us to remember your settings and provide a more personalized experience.",
      },
      marketing: {
        title: "Marketing",
        description: "They are used to tailor advertising content and measure the effectiveness of marketing campaigns.",
      },
      externalMedia: {
        title: "External media",
        description: "They enable embedded content from external services such as maps, videos, or social widgets.",
      },
    },
    acceptSelected: "ACCEPT SELECTED",
  },
  home: {
    heroAria: "Hero slider",
    sliderIndicators: "Slider indicators",
    slides: [
      {
        id: "s1",
        title: "A premium gym for private use",
        subtitle: "Train without crowds, on top-tier equipment, in an elegant interior.",
        primaryLabel: "BOOK NOW",
        primaryTo: "/rezerwacja#kalendarz",
        secondaryLabel: "HOW TO START",
        secondaryTo: "/jak-zaczac",
      },
      {
        id: "s2",
        title: "Are you a personal trainer?",
        subtitle: "Join our team today!",
        primaryLabel: "COOPERATION",
        primaryTo: "/wspolpraca",
      },
      {
        id: "s3",
        title: "AI Checkup",
        subtitle: "Precision diagnostics powered by data and artificial intelligence",
        primaryLabel: "BOOK A CHECKUP",
        primaryTo: "/ai-checkup",
      },
    ],
    about: {
      aria: "About us",
      title: "ABOUT US",
      text1: "We are creating a new quality of training in Lodz: a private self-service gym for exclusive use, designed for everyone from beginners to advanced athletes. You book online, enter with a code, and have the entire venue to yourself for the full duration of your reservation, with no crowds, queues, or unwanted attention.",
      text2: "You can train alone, with a companion, or with a personal trainer. Everything is possible here. On top of that, you get 100% Technogym equipment, an ecosystem with modern AI features, Checkup + Visio, premium air quality, and professional Bluetooth sound.",
    },
    features: {
      items: [
        {
          title: "HEALTHY AIR",
          desc: "Cleanliness and regular disinfection",
          details: [
            "Consistent thermal comfort during training, without stale air",
            "Air is purified, humidified, and ionized for a noticeably fresher feel",
            "Premium technologies: Panasonic Etherea nano™ X + Sharp",
            "A microclimate refined like a private studio, not a typical gym",
          ],
        },
        {
          title: "MODERN TECHNOLOGY",
          desc: "AI and smart checkup",
          details: [
            "Intelligent systems supporting comfort and training quality",
            "Premium-grade technologies working automatically in the background",
            "A consistent standard regardless of time of day or training intensity",
            "Solutions known from private studios and premium facilities",
          ],
        },
        {
          title: "TIME SAVING",
          desc: "Train without queues",
          details: [
            "Your workout starts exactly at your reserved time, with no waiting",
            "No queues for equipment or space",
            "Everything is ready from the first minute of your booking",
            "Maximum efficiency in every visit",
          ],
        },
        {
          title: "FULL PRIVACY",
          desc: "Comfort for everyone",
          details: [
            "A space just for you, or for you and your trainer",
            "No crowds and no random people around",
            "Complete focus on your training and goals",
            "Mental comfort and freedom that a traditional gym cannot offer",
          ],
        },
        {
          title: "PREMIUM EQUIPMENT",
          desc: "Biomechanically advanced",
          details: [
            "Technogym equipment",
            "A guarantee of top quality",
            "Full ergonomics",
            "Premium standard",
          ],
        },
      ],
    },
    equipment: {
      title: "EQUIPMENT",
      desc1: "Throughout the entire venue, you use only Technogym equipment, a premium brand known for top build quality, ergonomics, and refined details. This is not a random set of machines. We are building a cohesive, modern training ecosystem in which devices work with the app, save your workouts, and help you train smarter thanks to advanced data-driven AI features.",
      desc2: "You also have access to Technogym Checkup, which provides diagnostics and a starting point for your plan, and Technogym Visio, which guides your workout step by step on a large screen. The result? A professional premium-studio standard, but exclusively for you and at your own pace.",
      items: [
        { label: "Cardio and diagnostics", id: "Cardio" },
        { label: "Strength machines", id: "Maszyny" },
        { label: "Benches, racks and strength zone", id: "Strefa" },
        { label: "Free weights", id: "Ciezary" },
        { label: "Accessories and functional training", id: "Akcesoria" },
      ],
    },
    gallery: {
      title: "GALLERY",
      images: ["Gallery 1", "Gallery 2", "Gallery 3", "Gallery 4"],
    },
    contact: {
      title: "CONTACT",
      lead1: "Do you have questions or want to learn more?",
      lead2: "Get in touch with us. We will be happy to help and clear up any doubts.",
      labels: {
        name: "Full name*",
        email: "Email address*",
        subject: "Subject",
        message: "Message",
      },
      placeholders: {
        name: "John Smith",
        email: "name@example.com",
        subject: "Enter the subject of your message",
        message: "Enter your message",
      },
      errors: {
        name: "Name is required.",
        subject: "Subject is required.",
        emailRequired: "Email address is required.",
        emailInvalid: "Invalid email format.",
        message: "Message cannot be empty.",
        send: "An error occurred while sending your message.",
      },
      success: "Sent successfully!",
      submit: "SEND",
      locationAria: "Location preview",
      address: "6 Krzysztofa Cedry St., Lodz",
    },
  },
  aboutPage: {
    main: {
      title: "ABOUT US",
      lead: "In Lodz, we are creating a place that has been missing until now: a self-service gym for exclusive use, a private training studio where peace, comfort, and real quality matter.",
      p1: "This solution is for everyone: beginners who want to start without feeling self-conscious, and advanced users who value focus and no queues for equipment. Here, you do not just drop by the gym. You reserve it.",
      p2: "How does it work? You book online by choosing the day, start time, and workout duration. After payment, you receive an access code that works only during your time slot. For the entire reserved slot, the venue is exclusively yours: full privacy, full freedom, and zero random people around you.",
      p3: "You can train exactly how you want: alone, with a companion, or with a personal trainer. Want silence and focus? You can. Want to train as a duo? You can. Want to come in with a trainer and have a private space? You can do that too. Everything is possible here because you are in control of your training.",
      claimWhite: "WE FOCUS ON QUALITY",
      claimRed: "WITHOUT COMPROMISE",
    },
    details: {
      aria: "Details",
      image1: "Workout",
      image2: "Technogym equipment",
      image3: "Training zone",
      premiumTitle: "Premium equipment",
      premiumP1: "Inside, we have chosen a premium standard: 100% of the equipment is Technogym, a professional brand known for smart solutions and a cohesive training ecosystem.",
      premiumP2: "Training can be supported by data and modern AI functions, making progress measurable.",
      premiumP3: "We also offer Technogym CheckUp, diagnostics with a report that helps assess your condition and monitor progress, and Technogym Visio, which guides your workout step by step on a large screen at your own pace.",
      bookCheckup: "BOOK A CHECKUP",
      appTitle: "Technogym app",
      appP1: "The Technogym app plays an important role in this ecosystem and is available free of charge to our clients. The account is assigned to the venue.",
      appP2: "The app saves your workouts, organizes your history and progress, and makes every session easier to start. You log in to devices, for example with a code or QR, and the equipment remembers your settings.",
      appP3: "You can also build or generate a workout plan in the app based on your goal and available time, then complete it at the gym. The plan is created at home and executed on site.",
      appDownload: "Download the Technogym app:",
      qrPlaceholder: "QR code placeholder",
      qrTitle: "Download the app",
      qrText: "Scan the QR code to open the Technogym app link.",
      qrAlt: "QR code for the Technogym app",
      comfortTitle: "Comfortable and healthy training",
      comfortP1: "We also care about what is often underestimated in training: air and microclimate. During effort, you breathe more intensely and need more oxygen, so we use premium-class solutions: Panasonic Etherea air conditioning with nanoe X and Sharp KI-TX100EU-H, a premium purifier with Plasmacluster ionization and humidification.",
      comfortP2: "This is complemented by regular hygiene procedures, including ozonation, and a carefully refined atmosphere throughout the venue.",
      comfortP3: "You can set conditions exactly the way you like thanks to Grenton smart home, with temperature and lighting intensity controlled in one place and scene creation available. The atmosphere is completed by sound: professional Denon + JBL audio and Bluetooth, so you can train to your own music and at your own rhythm.",
    },
  },
  virtualWalk: {
    title: "Virtual walk",
    descriptionLine1: "Take a virtual walk and explore our gym without leaving your home.",
    descriptionLine2: "Get to know the Alfa Gym space and see what training on your terms looks like.",
    panoramaAlt: "Alfa Gym panorama",
    viewerHint: "Drag to look around the room. Use scroll or pinch to zoom.",
    loading: "Loading the virtual walk...",
    error: "Failed to load the virtual walk. Please try again later.",
  },
  underConstruction: {
    labelTop: "Page",
    labelBottom: "under construction",
    headlineTop: "Coming",
    headlineBottom: "Soon",
  },
  reservation: {
    top: {
      title: "Book now",
      lead: "Booking our self-service gym is quick and intuitive.",
      p1: "Just choose a convenient day and training time, then reserve a time slot tailored to your needs.",
      p2: "All occupied slots are visible in the calendar, so you immediately know which hours are already booked and can easily plan your workout.",
      howItWorks: "how it works",
    },
    details: {
      title: "HOW DOES IT WORK?",
      steps: [
        {
          title: "1. Choose a date",
          text: "In the calendar you will only see days that still have available slots, so you can be sure every selected date is actually available.",
        },
        {
          title: "2. Set the workout duration",
          text: "Decide how much time you want to spend training. Based on that, the system will suggest available start times.",
        },
        {
          title: "3. Choose your training time",
          text: "From the suggested time ranges, choose the hour that best fits your schedule. Only available slots are shown.",
        },
      ],
      trainingTitle: "4. Choose the type of training",
      trainingIntro: "Match the training to your needs:",
      trainingOptions: [
        "on your own — complete freedom and privacy",
        "with a companion — train together with someone close to you",
        "with a personal trainer — choose a professional from our trainer base and work under their guidance",
        "with a personal trainer for 2 people — a shared session for you and your companion led by one trainer",
      ],
      coachTitle: "5. Choose a personal trainer",
      coachText: "If you decide to train with a trainer, choose the right specialist for yourself or for you and another person from our list of cooperating personal trainers. Each profile includes basic information that makes it easier to match a trainer to your training goals.",
      trainers: "Our trainers",
      pricingText: "It is worth checking the price list, where you will find detailed information about the costs of each type of training. Prices vary depending on the selected format: solo training, training with a companion, or with a personal trainer, individually or for two people.",
      priceList: "Pricing",
      warningAlt: "Warning",
      warningText: "Please pay special attention to the 15-minute breaks between workouts. During this time the room is ozonated, so it is very important to leave the gym on time according to the end of your reservation.",
      imageAlt: "Background photo",
    },
    checkoutBlocked: "We open on 08.07 — bookings start from that day. Please pick a later date!",
    noCoach: "No trainer",
    slotTaken: "Selected slot is already taken. Please choose another time.",
    saved: "Your booking has been saved successfully!",
    saveError: "An error occurred while saving the booking.",
    expiredCart: "The booking in your cart has already been reserved and paid for or has expired.",
    trainerConsent: {
      title: "Important information about trainer bookings",
      text: "AlfaGym as a club does not provide a trainer as part of this booking.\n\nWhen you choose the trainer entry option, you come with your own trainer, with whom you arrange the session and settlement independently.\n\nIf you do not have your own trainer, you can contact trainers cooperating with AlfaGym, whose list you can find under Offer / Cooperation, and agree the training details with them individually.\n\nIf your trainer is not yet on the list, they should contact us in advance, complete the verification process, and be added to our database. Once the trainer is added to the system, you will be able to select them during booking without any additional fee for their entry.",
      checkbox: "I confirm that I have read and understood this information.",
      requiredError: "This field is required.",
      cancel: "Back",
      confirm: "I understand",
    },
    stepsTitles: {
      date: "Booking date",
      duration: "Workout duration",
      startTime: "Start time",
      trainingType: "Training type",
      coach: "Personal trainer",
      summary: "Summary",
    },
  },
  checkout: {
    title: "SUMMARY",
    deletedPackage: "Package removed from the cart",
    bookingRemoved: "Booking removed.",
    bookingDeleteError: "An error occurred while removing the booking.",
    summary: {
      title: "Selected products",
      empty: "No products in the cart",
      bookGym: "Book the gym",
      total: "TOTAL TO PAY",
      reservationInfo: "Your reservations will be added to the calendar immediately after successful payment.",
      trainingTypeMap: {
        individual: "Individual",
        two_people: "2 people",
        one_plus_trainer: "1 person + trainer",
        two_plus_trainer: "2 people + trainer",
      },
    },
  },
  offer: {
    section: {
      title: "Offer",
      leadTitle: "A private gym for exclusive use",
      leadAccent: "you book it, enter with a code, and train your way.",
      leadText: "You choose the day, start time, and duration. During your booking, the venue is only for you or your group, with no crowds, no queues, and no pressure. Train solo, as a duo, or with a personal trainer. Everything is possible here.",
      passTitle: "If you train regularly, choose a gym pass.",
      passText: "10 entries in your chosen time and people variant. The pass is valid for 30 days from purchase. After it expires, unused entries do not roll over to the next period.",
      book: "Book a slot",
      contact: "Contact",
    },
    pricing: {
      title: "Pricing",
      time: "Time",
      price: "Price",
      pass: "Gym passes",
      package: "Package",
      soloTitle: "SOLO entries (1 person)",
      soloDesc: "For people who want maximum privacy, peace, and full focus.",
      duetTitle: "DUET entries (2 people)",
      duetDesc: "For couples and friends who want to train together, without strangers in the background.",
      checkupTitle: "CheckUp assessment",
      checkupDesc: "For people who want to understand their current fitness, condition, and training potential in one session, based on real numbers.",
      warning: "Packages are valid for 90 days from purchase. After the expiry date, unused assessments do not carry over to the next period.",
      buyPass: "BUY PASS",
    },
    info: {
      topClaimWhite: "SOLO, DUET, TRAINER",
      topClaimRed: "YOU CHOOSE!",
      trainerTitle: "Personal trainer",
      trainerP1: "A personal trainer enters at no extra charge.",
      trainerP2: "Available training formats:",
      trainerOptions: ["1 client + trainer", "2 clients + trainer"],
      trainerP3: "Important: for a trainer to enter, they must be added to our system as a cooperating trainer. During booking, you select your personal trainer from the list.",
      trainerP4: "We invite personal trainers to cooperate with us on special terms.",
      cooperation: "Cooperation",
      reservationTitle: "Individual reservations",
      reservationP1: "Need a custom time slot? It is possible: longer blocks, full-day exclusive bookings, photo or video sessions, and social media recordings.",
      reservationP2: "In such cases, please contact us. We will prepare an individual quote and match availability.",
      contact: "Contact",
      bottomClaimWhite: "NEED MORE TIME?",
      bottomClaimRed: "WE CAN DO THAT!",
    },
    faq: {
      title: "Frequently asked questions",
      items: [
        {
          q: "What is AlfaGym?",
          a: "AlfaGym is a premium gym created for people who want to train in calm, comfortable conditions, without crowds or random chaos.\n\nIt is a place for people who value privacy, high-quality equipment, and the ability to focus fully on training.\n\nAt AlfaGym, you use modern, advanced equipment supported by artificial intelligence, which helps you train more consciously and match exercises better to your goals. On site, you also have access to audio amenities and solutions that support clean, comfortable air during training, so the whole space promotes better well-being and concentration.",
          defaultExpanded: true,
        },
        {
          q: "Who is AlfaGym for?",
          a: "AlfaGym is for people who want to train consciously, comfortably, and in a more private environment.\n\nIt works well both for beginners and for those who already train regularly and are looking for a place with a higher standard.\n\nIt is a good option if you want to:\n• start exercising without stress,\n• improve your physique,\n• build strength,\n• take care of your health and fitness,\n• train without crowds,\n• use professional equipment,\n• have a more individual approach.",
        },
        {
          q: "Is AlfaGym suitable for beginners?",
          a: "Yes, AlfaGym is a good place for beginners.\n\nYou do not need experience or knowledge of every exercise. You can start calmly, at your own pace, and use the support of our team.\n\nIf you do not know where to start, we will help you choose the right training direction for your goal and current abilities.",
        },
        {
          q: "Can I train on my own?",
          a: "Yes, at AlfaGym you can train on your own.\n\nYou use the space and equipment in comfortable, private conditions, without crowds or rush. You can focus on your own training, work at your own pace, and use the available amenities.",
        },
        {
          q: "How many people can enter the gym?",
          a: "The gym can host 1 or 2 people, depending on the selected option, plus an optional personal trainer.",
          defaultExpanded: false,
        },
        {
          q: "Will anyone else be in the venue during my booking?",
          a: "No. During your slot, the gym is exclusively for you or your group.",
          defaultExpanded: false,
        },
        {
          q: "Can I come with a personal trainer?",
          a: "Yes. The trainer enters free of charge, but must be added to our system as a cooperating trainer. During booking, you choose the trainer from the list.",
        },
        {
          q: "Can a trainer come with two people?",
          a: "Yes. The trainer + 2 people option is available.",
        },
        {
          q: "Can I book more than 3 hours or the whole day?",
          a: "Yes. Custom reservations are handled on request, including longer blocks and full-day bookings.",
        },
        {
          q: "Can I do a photo session or social media recording?",
          a: "Yes. After contact, we agree on the schedule, rules, and pricing.",
        },
        {
          q: "How do I get inside?",
          a: "After booking, you receive an access code active only during your selected time slot.",
        },
        {
          q: "Solo vs duet: what exactly does duet mean?",
          a: "A duet is one exclusive slot for two people.",
        },
        {
          q: "Where can I find trainer cooperation details?",
          a: "In the “Personal trainer - cooperation” section.",
        },
      ],
    },
  },
  gymPassPackages: {
    title: "PASSES",
    lead: "Choose the pass that best fits your training routine.",
    leadRed1: "If you train regularly, choose a pass with 10 entries in your selected time and people variant.",
    buy: "BUY PASS",
    infoEyebrow: "Important information",
    infoTitle: "How the pass works",
    info1: "Each pass is valid for <strong>45 days</strong> from the purchase date. After the expiration date, unused entries do not roll over to the next period.",
    info2: "After purchasing a pass, you will receive an individual code. You use the same code for every booking within your 10 entries. During booking, select the <strong>“Use pass”</strong> option and enter the code you received. The system will automatically deduct the used entry, and after the booking it will send an email with information about your remaining entries.",
    description: {
      eyebrow: "Pass details",
      title: "Included with every pass",
      items: [
        "Access to a premium private gym",
        "Training without crowds or queues",
        "Advanced training equipment",
        "Result tracking in the Technogym app",
        "A comfortable, boutique workout space",
        "Clean air and audio amenities",
      ],
    },
  },
  payment: {
    successTitle: "Payment completed successfully!",
    successText: "We have sent your booking confirmation to your email address.",
    successCta: "back to the calendar",
    failedTitle: "Payment failed...",
    failedText: "The transaction could not be completed. Try again or choose a different payment method.",
    failedCta: "back to payment",
  },
  notFound: {
    title: "404",
    eyebrow: "Wrong direction",
    subtitle: "The workout got interrupted here, but we can get you back on track fast.",
    text: "The page you are looking for does not exist or has been moved.",
    highlightTraining: "Training",
    highlightRecovery: "Recovery",
    highlightStrength: "Strength",
    backHome: "BACK TO HOME PAGE",
    seeOffer: "SEE THE OFFER",
    tileOneLabel: "Best move",
    tileOneValue: "Back to start",
    tileTwoLabel: "Alternative",
    tileTwoValue: "View the offer",
  },
  checkup: {
    hero: {
      title: "AI CHECKUP",
      features: ["Precision diagnostics", "Conscious training", "Measurable results"],
      book: "Book a checkup",
      howItWorks: "How does it work?",
    },
    advanced: {
      title: "Advanced diagnostics",
      subtitle: "powered by artificial intelligence",
      description: "In a single session, you receive a complete picture of your fitness, condition, and training potential in numbers that truly matter. It is a starting point for data-driven training instead of guesswork.",
      withoutTitle: "Without checkup",
      withoutItems: ["You train by feel", "You do not know whether you are progressing", "One scheme for everyone", "Results are hard to measure", "Motivation drops"],
      withTitle: "AI Checkup",
      withItems: ["You train based on data", "You see real progress", "Training tailored to you", "Results confirmed by numbers", "Motivation grows with every result"],
      processTitle: "How AI Checkup works",
      steps: [
        { title: "Buy and book CheckUp", text: "Contact us to arrange your assessment date. You can buy and pay for the assessment through the website or on site." },
        { title: "Diagnostics (about 60 min)", text: "At the agreed time in our gym, a comprehensive assessment of your fitness, strength, mobility, and condition is carried out on the Technogym Checkup device." },
        { title: "AI analysis", text: "The system analyzes your results, compares them to benchmarks, and calculates, among other things, your Wellness Age." },
        { title: "Premium report", text: "You receive a detailed multi-page report with your results and conclusions." },
        { title: "Technogym app", text: "All data is saved in the app, so you have a measurement history and can track your progress." },
      ],
      appDownload: "Download the Technogym app",
      qrTitle: "Download the app",
      qrText: "Scan the QR code to open the Technogym app link.",
      qrAlt: "QR code for the Technogym app",
      timeline: ["BUY", "BOOK", "FIND YOUR WELLNESS AGE"],
      metricsTitle: "What we measure",
      metrics: [
        { title: "Fitness and function", items: ["muscle strength", "stability", "body symmetry"] },
        { title: "Mobility", items: ["range of motion", "limitations", "movement patterns"] },
        { title: "Condition", items: ["endurance", "effort tolerance", "recovery"] },
        { title: "Body composition", items: ["muscle mass", "body fat", "proportions"] },
        { title: "Wellness Age", items: ["biological age", "overall fitness level"] },
      ],
    },
    forWhom: {
      title: "WHO IS IT FOR",
      p1: "AI Checkup is for anyone who wants to train consciously and see real results. It works well both for people starting their training journey, who want to take safe and smart first steps, and for those who already train regularly but expect concrete information, numbers, and clear feedback on progress.",
      p2: "It is also a great solution for people returning to activity after a break, those who want to better understand their body’s capabilities, and everyone who values modern technology, data, and measurable progress instead of guesswork and training by feel.",
      claimWhite: "THIS IS NOT\nA ONE-TIME TEST.",
      claimRed: "IT IS THE FOUNDATION\nOF CONSCIOUS TRAINING.",
    },
    packages: {
      title: "AI CHECKUP PACKAGES",
      lead: "Choose the package that matches your training goals.",
      leadRed: "A FREE TRAINING PLAN WITH EVERY ASSESSMENT!",
      buy: "BUY PACKAGE",
      valid1: "Packages are valid for 90 days from purchase.",
      valid2: "After the validity period, unused assessments do not carry over to the next period.",
      packages: [
        { title: "Single Checkup", subtitle: "The ideal start and reference point", bullets: ["full body condition diagnostics", "discover your Wellness Age", "a clear starting point for training", "detailed premium report", "results saved in the Technogym app", "free training plan included with every package"] },
        { title: "3 Checkups Package", subtitle: "See real progress over time", bullets: ["compare results over time", "track training progress", "better motivation through visible changes", "ability to adjust training based on data", "full measurement history in the app", "free training plan included with every package"] },
        { title: "6 Checkups Package", subtitle: "Full control and long-term development", bullets: ["long-term fitness monitoring", "maximum use of training data", "quick detection of stagnation or overload", "conscious step-by-step progress building", "complete documentation of body changes", "free training plan included with every package"] },
      ],
      faq: [
        {
          q: "What is AI Check Up at AlfaGym?",
          a: "AI Check Up is a comprehensive analysis of your current fitness level that helps you better understand your body and use that information for more conscious training and a clearer action plan.\n\nDuring the check-up, we assess the key parameters related to conditioning, movement, and overall performance. The results help identify what is worth working on first and how to better match training to your goal, experience level, and capabilities.\n\nIt is a strong first step if you want to train smarter, more consciously, and without choosing exercises at random.",
          defaultExpanded: true,
        },
        {
          q: "How does AI Check Up work step by step?",
          a: "After booking the AI Check Up service, you will receive a short form about your health, activity level, and training goal.\n\nThe completed information is included in the analysis, which makes the whole process better tailored to you.\n\nWhen you arrive at AlfaGym, our staff member performs the Check Up on site. The whole process is simple and comfortable, and we guide you through every step.\n\nIn practice, it looks like this:\n1. You book the AI Check Up service.\n2. You receive a short form to complete.\n3. In the form, you answer questions about your health, activity, and training goal.\n4. You arrive at AlfaGym at the scheduled time.\n5. Our staff member performs the Check Up analysis.\n6. After the assessment, you receive a detailed report and a training plan generated by advanced artificial intelligence.\n\nPlease remember: to complete the AI Check Up analysis, you need to have the Technogym app. It is worth installing it before your visit so the whole process runs smoothly.",
        },
        {
          q: "Can I perform AI Check Up on my own?",
          a: "No, AI Check Up is not performed independently.\n\nThe Check Up device is not available for self-service use and may only be operated by an AlfaGym representative.\n\nThe assessment is carried out by a member of our gym staff who has been properly trained to use the device and manage the full analysis process. Thanks to that, you can be sure the check-up is done correctly, safely, and in line with the procedure.",
        },
        {
          q: "How should I prepare for AI Check Up?",
          a: "It is best to come in comfortable sportswear and avoid heavy training immediately before your visit.\n\nIt is also a good idea to bring water and arrive a few minutes early so you can start the analysis calmly.\n\nIt helps if you already know your main goal before the check-up: fat loss, physique development, strength improvement, getting back into shape, or general health improvement.",
        },
        {
          q: "Will AI Check Up help choose a training plan?",
          a: "Yes, that is exactly what AI Check Up is for.\n\nThe results help match training more accurately to your level, goal, and capabilities. Thanks to that, the plan is not random but based on real data.\n\nThis is especially important if you want to avoid training a lot without getting a specific result.",
        },
        {
          q: "Is AI Check Up suitable for beginners?",
          a: "Yes. AI Check Up is a very good solution for people who are just getting started.\n\nAt the beginning, the hardest part is often not knowing where to start. The check-up brings structure and shows which direction is likely to be best for you.\n\nYou do not need to already be fit to come for AI Check Up. The point of the check-up is to help assess your starting point.",
        },
        {
          q: "Is it worth doing AI Check Up if I already train?",
          a: "Yes, especially if you train regularly but want better control over your progress.\n\nAI Check Up can show whether your training is really improving the things you care about. Sometimes the results show that it is worth changing the focus: more strength, more mobility, better recovery, or a different exercise selection.\n\nIt is a good option for people who do not want to train by guesswork.",
        },
        {
          q: "Does AI Check Up replace a medical examination?",
          a: "No. AI Check Up is not a medical examination and does not replace consultation with a doctor.\n\nIt is a tool that supports fitness assessment and training selection. If you have chronic conditions, recent injuries, severe pain, or contraindications to exercise, consult a doctor or physiotherapist first.\n\nAt AlfaGym, we treat safety as the foundation of good training.",
        },
        {
          q: "How long does AI Check Up take?",
          a: "AI Check Up takes about 60 minutes.\n\nIt is worth planning a calm visit without rushing. This gives us enough time to carry out the analysis thoroughly, discuss the most important information, and prepare a detailed report together with a training plan generated by advanced artificial intelligence.\n\nThis is enough time not only to complete the assessment, but also to better understand the results and learn how to use them in more conscious training.",
        },
        {
          q: "How often is it worth repeating AI Check Up?",
          a: "It is best to repeat AI Check Up regularly to track progress and update your training direction.\n\nFor most people, a good rhythm will be doing the check-up every few weeks, depending on the goal and training intensity.\n\nRegular measurement helps you see whether your body is really changing in the right direction.",
        },
        {
          q: "Is AI Check Up safe?",
          a: "Yes, AI Check Up is non-invasive and performed in comfortable conditions.\n\nIts purpose is to better understand your starting point and match training to your capabilities.\n\nIf you have any limitations, pain, or concerns, let us know before starting. That way, both the analysis and the recommendations that follow can be better tailored to you.",
        },
      ],
    },
  },
  cooperation: {
    top: {
      title: "Cooperation",
      heading: "PERSONAL TRAINER / PHYSIOTHERAPIST",
      accent: "Work with clients in a premium private studio in Lodz",
      p1: "We invite personal trainers, physiotherapists, and strength & conditioning specialists to cooperate with us.",
      p2: "We offer a comfortable private space for exclusive use and premium Technogym equipment with modern features that make it easier to lead training sessions and build long-term results for your clients.",
      cta: "Contact us",
    },
    benefits: {
      title: "Why is it worth cooperating?",
      items: [
        { title: "Privacy and comfort when working with a client", desc: ["exclusive gym access in the time slot, with zero random people in the background", "great conditions for teaching technique, correction, and 1:1 / 2:1 work", "psychological comfort for the client, also ideal for beginners and people returning after a break"] },
        { title: "100% Technogym equipment (premium)", desc: ["the entire venue is equipped exclusively with Technogym, ensuring consistent quality, ergonomics, and standard", "professional machines, free weights, and accessories for strength, functional, and complementary training in one place", "premium equipment that raises the value of your service"] },
        { title: "Technology that makes coaching easier", desc: ["Technogym Visio guides training step by step on a large screen, improving clarity and reducing chaos", "the Technogym ecosystem provides a coherent training experience and enables data-based work"] },
        { title: "Technogym app for convenient client work", desc: ["plan, training history, and progress in one place", "easier communication and control of consistency between sessions", "better organized training: plan in the app, execution at the gym"] },
      ],
    },
    trainer: {
      title: "How does entry with a trainer work?",
      subtitle: "If the client already has their own trainer or physio and wants to train with them at our place:",
      steps: [
        "you contact us and we add you to the system as a cooperating trainer",
        "from that moment, the client selects your name from the list during booking",
        "thanks to this, the system recognizes the session as training with a trainer and the trainer enters free of charge",
      ],
      sessionConfigs: "Possible session setups:",
      configs: ["1 client + trainer", "2 clients + trainer"],
      coachesList: "List of cooperating personal trainers",
    },
    details: {
      aria: "Cooperation details",
      title1: "Technogym Checkup for your clients",
      accent1: "on special terms",
      p1: "By cooperating with us, you can perform Technogym Checkup for your clients as part of the training or therapy process: diagnostics, starting point, measurable progress, and monitoring. Checkup for trainers is available on special terms to be agreed after contact. You can also find details in the AI Checkup section.",
      title2: "Promotion of trainers on our website",
      p2: "For trainers and specialists cooperating with us, we also offer the possibility of presentation or promotion on our website, for example a profile, specialization, and contact or social links. The scope and conditions are agreed individually depending on the form of cooperation.",
      title3: "Special reservations",
      accent3: "sessions, recordings, longer blocks",
      p3: "Need more time to work with a client, want to make a video session, or create content for social media? That is possible with us and arranged individually after contact.",
    },
    trainers: {
      title: "They worke with us",
      comingSoon: "Trainers will appear in this section soon.",
      qualifications: "Qualifications",
    },
    contact: {
      title: "Contact us",
      p1: "Want to be added to the system and enter with clients without a trainer fee?",
      p2: "Write to us briefly:",
      bullets: ["what you do", "what model you work in", "which time slots interest you"],
      pBold: "— we will get back to you with details.",
      arrowAlt: "red arrow",
    },
  },
  contactPage: {
    formTitle: "Contact form",
    formLead1: "Do you have questions about training or cooperation?",
    formLead2: "Write to us and we will reply as quickly as possible.",
    privacyConsentStart: "I accept the",
    terms: "terms",
    and: "and",
    privacy: "privacy policy",
    privacyError: "You must accept the terms and privacy policy.",
    locationTitle: "Location",
    gymLocationTitle: "Our gym location",
    gymLocationText: "This is the exact location of our gym and directions on how to get there.",
    parkingTitle: "Parking location for our clients",
    parkingText: "This is where the parking spot for our clients is located.",
  },
  equipmentPage: {
    panelFeatures: "Key features",
    panelSpecs: "Specifications",
  },
  virtualWalkPage: {
    title: "Virtual walk",
    lead: "Take a virtual walk and see our gym without leaving home.<br/>Explore the alfaGym space and see what training on your own terms looks like.",
    panoramaAlt: "AlfaGym panorama",
  },
  reportIssuePage: {
    title: "Report an issue",
    lead1: "Share the details of the problem.",
    lead2: "Fill out the form and your report will be saved as a document in the Firestore collection.",
    labels: {
      fullName: "Full name",
      email: "Email address",
      reportDate: "Report date",
      description: "Issue description",
      photos: "Photos (max {{count}})",
    },
    placeholders: {
      fullName: "John Smith",
      description: "Describe what is not working, where the problem occurs and when it was noticed.",
    },
    photos: {
      hint: "You can add up to {{count}} photos from your gallery or camera.",
      add: "Add photo",
      removeAria: "Remove photo {{name}}",
      removeTitle: "Remove photo",
    },
    errors: {
      fullName: "Please enter your full name.",
      emailRequired: "Please enter your email address.",
      emailInvalid: "Please enter a valid email address.",
      description: "Please describe the issue.",
      photosCount: "You can add a maximum of {{count}} photos.",
      photosSize: "The maximum photo size is {{maxMb}} MB. Skipped: {{names}}.",
      submit: "Failed to send the report.",
    },
    submit: "Send report",
    successTitle: "Report submitted",
    successId: "Report ID: {{id}}",
  },
  calendar: {
    next: "Next",
    previous: "Previous",
    today: "Today",
    month: "Month",
    week: "Week",
    day: "Day",
  },
  checkoutForm: {
    fullNameRequired: "Enter your full name",
    emailInvalid: "Invalid email format",
    phoneShort: "Phone number is too short",
    smsConsent: "You must accept SMS notifications",
    termsConsent: "You must accept the terms and privacy policy",
    companionRequired: "Enter the companion's full name",
    companionFormat: "Enter first and last name separated by a space",
    passCode: "Enter the gym pass code",
    companyRequired: "Company name is required",
    invalidNip: "Invalid VAT ID number",
    streetRequired: "Street is required",
    zipFormat: "Postal code must be in the format XX-XXX",
    cityRequired: "City is required",
    passExpired: "The gym pass has expired",
    passEmpty: "No entries left on the pass",
    passMismatch: "The pass is valid for {{time}} min {{type}} bookings, but a different session was selected.",
    purchasesBlocked: "Your cart contains a booking before our 08.07 opening. Please remove it to continue.",
    applyPassFirst: "Please confirm the pass first using the APPLY button",
    invalidVoucher: "The promo code is invalid",
    serverError: "Server error. Please try again later.",
    connectionError: "Connection error.",
    passOnlyReservations: "The gym pass supports reservations only. Remove other items from the cart to use it.",
    invalidPassCode: "Invalid pass code.",
    passOnlyCount: "You only have {{left}} entries, but there are {{count}} workouts in the cart.",
    passProcessingError: "Error while processing the pass",
    fieldsPrefix: "Please complete the required fields: {{fields}}",
    fieldsMap: {
      clientName: "Full name",
      clientEmail: "Email address",
      clientPhoneNumber: "Phone number",
      smsConsent: "SMS notification consent",
      regulaminConstent: "Terms acceptance",
      accompanyingName: "Companion full name",
      passCode: "Gym pass code",
      companyName: "Company name",
      nip: "VAT ID",
      street: "Street",
      zipCode: "Postal code",
      city: "City",
    },
    trainingTypeMap: {
      individual: "Individual",
      two_people: "2 people",
      one_plus_trainer: "1 person + trainer",
      two_plus_trainer: "2 people + trainer",
    },
    section1: "1. Your details",
    sectionCompanion: "Companion",
    section2: "2. Payment",
    section3: "3. Discounts",
    labels: {
      fullName: "Full name*",
      email: "Email address",
      phone: "Phone number",
      acceptAll: "I accept all consents",
      acceptTermsStart: "I accept the",
      terms: "terms",
      and: "and",
      privacy: "privacy policy",
      sms: "I agree to receive text messages regarding order updates",
      newsletter: "I want to subscribe to the newsletter",
      companion: "Full name*",
      paynow: "Pay with Paynow",
      usePass: "Use gym pass",
      onSite: "Pay on site",
      passCode: "Gym pass code",
      invoice: "I want to receive an invoice",
      companyName: "Company name",
      nip: "VAT ID",
      street: "Street",
      zipCode: "Postal code",
      city: "City",
      promoCode: "Promo code",
      total: "TOTAL TO PAY",
      buy: "Buy and pay",
    },
    placeholders: {
      fullName: "John Smith",
      email: "johnsmith@gmail.com",
      phone: "+48 641 154 798",
      companyName: "My Company Ltd.",
      street: "1 Sportowa St.",
      city: "Warsaw",
      promoCode: "--- --- ---",
    },
    actions: {
      remove: "REMOVE",
      apply: "APPLY",
      passActive: "ACTIVE PASS: {{code}}",
      promoActive: "ACTIVE CODE: {{code}}",
    },
  },
  privacyPolicy: privacyPolicyEn,
  termsPage: termsPageEn,
};

export default en;
